/* Lünnara — theme.js */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const moneyFormat = document.documentElement.dataset.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';

  // Respeta el formato de moneda configurado en la tienda (CLP no usa decimales)
  const formatMoney = (cents) => {
    const match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount_no_decimals';
    const sep = /comma_separator/.test(key) ? '.' : /apostrophe/.test(key) ? "'" : /space/.test(key) ? ' ' : ',';
    const value = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  };
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* Barra de anuncios rotativa */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* Menú móvil */
  const menuBtn = $('[data-menu-toggle]');
  const mobileNav = $('[data-mobile-nav]');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    $$('a', mobileNav).forEach((a) => a.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }));
  }

  /* Galería */
  $$('[data-gallery]').forEach((g) => {
    const slides = $$('.gallery__slide', g);
    const thumbs = $$('.gallery__thumb', g);
    const show = (idx) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === idx));
      thumbs.forEach((t, n) => { t.classList.toggle('is-active', n === idx); t.setAttribute('aria-current', n === idx); });
    };
    thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));
    // swipe en móvil
    let x0 = null;
    const main = $('.gallery__main', g);
    main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const cur = slides.findIndex((s) => s.classList.contains('is-active'));
      if (Math.abs(dx) > 40) show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      x0 = null;
    });
  });

  /* Selector de packs */
  $$('[data-product-form]').forEach((form) => {
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', form);
    const compareEl = $('[data-compare]', form);
    const btn = $('[type="submit"]', form);
    const sticky = $('[data-sticky-atc]');
    const update = (radio) => {
      idInput.value = radio.value;
      if (priceEl) priceEl.textContent = radio.dataset.price;
      if (compareEl) compareEl.textContent = radio.dataset.compare || '';
      btn.disabled = radio.dataset.available !== 'true';
      btn.querySelector('span').textContent = btn.disabled ? btn.dataset.soldOut : btn.dataset.add;
      if (sticky) {
        $('[data-sticky-variant]', sticky).textContent = `${radio.dataset.title} · ${radio.dataset.price}`;
      }
      if (form.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState({}, '', url);
      }
    };
    $$('input[name="pack"]', form).forEach((r) => r.addEventListener('change', () => update(r)));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'No se pudo agregar al carrito');
        }
        await Cart.open();
      } catch (err) {
        alert(err.message);
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  });

  /* Barra fija móvil: visible cuando el botón principal sale de pantalla */
  const sticky = $('[data-sticky-atc]');
  const mainBtn = $('[data-product-form] [type="submit"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainBtn);
    $('[data-sticky-buy]', sticky).addEventListener('click', () => {
      mainBtn.closest('form').requestSubmit();
    });
  } else if (sticky && !mainBtn) {
    sticky.classList.add('is-visible');
  }

  /* Carrito lateral */
  const Cart = {
    el: $('[data-cart-drawer]'),
    async fetch() {
      const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.dataset.count = n; });
    },
    render(cart) {
      this.setCount(cart.item_count);
      if (!this.el) return;
      const body = $('[data-cart-body]', this.el);
      const foot = $('[data-cart-foot]', this.el);
      if (!cart.item_count) {
        body.innerHTML = $('[data-cart-empty-tpl]', this.el).innerHTML;
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      body.innerHTML = cart.items.map((item, i) => `
        <div class="line">
          <div class="line__img">${item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=200" alt="${escapeHtml(item.product_title)}" width="84" height="84" loading="lazy">` : ''}</div>
          <div>
            <p class="line__title">${escapeHtml(item.product_title)}</p>
            ${item.variant_title ? `<p class="line__variant">${escapeHtml(item.variant_title)}</p>` : ''}
            <div class="qty">
              <button type="button" data-qty="${i + 1}" data-to="${item.quantity - 1}" aria-label="Quitar uno"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-qty="${i + 1}" data-to="${item.quantity + 1}" aria-label="Agregar uno"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>
            </div>
            <button type="button" class="line__remove" data-qty="${i + 1}" data-to="0">Quitar</button>
          </div>
          <div class="line__price">
            ${item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : ''}
            ${formatMoney(item.final_line_price)}
          </div>
        </div>`).join('');
      $('[data-cart-subtotal]', this.el).textContent = formatMoney(cart.total_price);
    },
    async open() {
      const cart = await this.fetch();
      this.render(cart);
      if (!this.el) { window.location.href = `${root}cart`; return; }
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      $('.drawer__close', this.el).focus();
    },
    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    async change(line, quantity) {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      this.render(await res.json());
    },
  };
  window.LunnaraCart = Cart;

  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); Cart.open(); }));
  if (Cart.el) {
    $$('[data-cart-close]', Cart.el).forEach((b) => b.addEventListener('click', () => Cart.close()));
    Cart.el.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]');
      if (b) Cart.change(Number(b.dataset.qty), Math.max(0, Number(b.dataset.to)));
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') Cart.close(); });
  }

  /* Aparición suave al hacer scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }
})();
